/*
 * Represents the models that compose the total returns table component.
 */

import {
  AnnualizedPeriodsPerformance,
  CurrentYearPeriodsPerformance,
} from '../total-returns/total-returns.model';

export enum TotalReturnsTableDataType {
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
}

export enum TotalReturnsTableType {
  AnnualizedPerformance = 'AnnualizedPerformance',
  CurrentYearPerformance = 'CurrentYearPerformance',
}

type CurrentYearPerformanceValues = {
  monthEnd: CurrentYearPeriodsPerformance;
};

type AnnualizedPerformanceValues = {
  monthEnd: AnnualizedPeriodsPerformance;
  quarterEnd: AnnualizedPeriodsPerformance;
};

export type TotalReturnsTable = {
  dataValueType: TotalReturnsTableDataType;
  tableType: TotalReturnsTableType;
  currentYearPerformanceValues: CurrentYearPerformanceValues | null;
  annualizedPerformanceValues: AnnualizedPerformanceValues | null;
  portfolioInceptionDate: string;
  assetClass: string;
};

export type TotalReturnsTableDataRow = {
  cellHeader: string;
  cellValue: string | number | null | undefined;
  isPercentage: boolean;
};

export type CurrentYearTableColumns = {
  MonthlyYTD: string;
  OneMonth: string;
  ThreeMonths: string;
};

export type CompositeTableColumns = {
  OneYear: string;
  ThreeYear: string;
  FiveYear: string;
  TenYear: string;
  SinceInception: string;
};

export type TotalReturnsRowNames = {
  PureGross: string;
  PureGrossFixedIncome: string;
  Net: string;
  NetFixedIncome: string;
  Benchmark: string;
  ValuePureGross: string;
  ValueNet: string;
};
